import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=76fa87eb&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=76fa87eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa87eb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgRender: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/SvgRender.vue').default})
